import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_STATUTORY_INFO);

const _pk_name = "id";

const state = {
  data: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const getters = {
  getData: (state)=>(code)=>{
      return state.data[code]
  }
}

const mutations = {
  set: (state,[payload,le_id, code]) => {
    state.data[code][le_id] = payload;
  },

  addData: (state, [payload,le_id]) => {
    // state.data[code].push(payload);
    state.data[le_id].push(payload)
  },

  updateData: (state, [payload,le_id,code]) => {
    // for(let i=0; i<state.data[code].length; i++) {
      if(state.data[code][le_id][_pk_name] === payload.id) {
        state.data[code][le_id]=payload
      }
    // }
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}, [le_id, code]) {
      //console.log("[state/onboard/misc/fetchAll] Calling API...");
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {params:
        {le_id :le_id, statuaryCode:code}
      });
      commit("setFetching", false);
      //console.log("[state/onboard/misc/fetchAll] res: ", res);
      if(res.status == 200) {
        commit("set", [res.data.rows[0],le_id,code]); //todo: Check for Pagination
      }
      return res;
    }catch(err) {
      //console.log(err)
    }
  },

  async create({commit}, payload) {
      //console.log("[state/onboard/misc/create] Adding...");
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/onboard/misc/create] res: ", res);
      if(res.status == 200) {
        commit("addData", [res.data.rows[0], payload.leId]);
      }
      return res;
    }catch(err) {
      //console.log(err)
    }
  },

  async update({commit}, payload) {
      //console.log("[state/onboard/misc/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put('/', payload);
      commit("setSaving", false);
      //console.log("[state/onboard/misc/update] res: ", res);
      if(res.status == 200) {
        commit("updateData", [res.data.rows[0], payload.leId, payload.statuaryCode ]);
      }
      return res;
    }catch(err) {
      //console.log(err)
    }
  },

  // async delete({commit}, payload) {
  //   //console.log("[state/onboard/statutory_info/delete] Payload:", payload);
  //   //console.log("[state/onboard/statutory_info/delete] Payload:", `/${payload.id}`);
  //   try {
  //     commit("setDeleting", true);
  //     let res = await axios_instance.delete(`/${payload.id}`);
  //     commit("setDeleting", false);
  //     if (res.status == 200){
  //       commit("removeEntityById", payload.id);
  //     }
  //   }catch(err) {
  //     //console.log(err)
  //   }
  // }
}

export default {
  namespaced: true,
  state, mutations, actions,getters
}
